import API from '../config/api';

const cookie = name => {
  const entry = document.cookie.split('; ').find(part => part.startsWith(name + '='));
  if (!entry) return '';
  try {
    return decodeURIComponent(entry.slice(name.length + 1));
  } catch {
    return '';
  }
};

export const getMetaContext = () => ({
  fbp: cookie('_fbp'),
  fbc: cookie('_fbc'),
  url: window.location.origin + window.location.pathname
});

export const trackMetaEvent = (eventName, customData = {}) => {
  const eventId = window.crypto?.randomUUID?.() || ('meta_' + Date.now() + '_' + Math.random().toString(36).slice(2));
  window.fbq?.('track', eventName, customData, { eventID: eventId });

  fetch(API + '/meta/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    keepalive: true,
    body: JSON.stringify({
      eventName,
      eventId,
      customData,
      meta: getMetaContext()
    })
  }).catch(() => {
    // Tracking must not interrupt shopping or navigation.
  });
};
